export default __webpack_public_path__ + "arc.67e3923d.svg";